//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { CuralateProductCatalog } from '@apis/universal-image-actions/universalImageActionsApiModel';
import { Product } from '@models/IItemMetadata';
import { isDefined } from '@utils/filterPredicates';
import { SerializedArray } from '@utils/types/Serialized';

export const deserializeCatalogs = (
  catalogs: SerializedArray<CuralateProductCatalog>,
): CuralateProductCatalog[] =>
  catalogs.map(({ created, lastUpdated, ...catalog }) => ({
    ...catalog,
    created: isDefined(created) ? new Date(created) : undefined,
    lastUpdated: isDefined(lastUpdated) ? new Date(lastUpdated) : undefined,
  }));

export const deserializeItemMetadataTags = (
  productTags: SerializedArray<Product>,
): Product[] =>
  productTags.map(({ created, lastUpdated, ...tag }) => ({
    ...tag,
    created: isDefined(created) ? new Date(created) : undefined,
    lastUpdated: isDefined(lastUpdated) ? new Date(lastUpdated) : undefined,
  }));
